//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'

export default {
  name:'BalthazarCTModified',
  data() {
    return {
      form:{
        edema:'',
        necro:'',
        complic:'0',
      },
      defaultJson:{
        "Normal pancreas": "正常胰腺",
        "Pancreatic inflammation": "胰腺炎症",
        "Intrinsic pancreatic abnormalities with or without inflammatory changes in peripancreatic fat": "胰腺内部异常改变伴或不伴胰周脂肪炎性改变",
        "Moderate Pancreatitis": "中度胰腺炎",
        "Normal": "正常",
        "Fluid": "积液",
        "> 30%": "> 30%",
        "≤ 30%": "≤ 30%",
        "Extrapancreatic complications": "胰外并发症",
        "None": "无",
        "Pancreatic necrosis": "胰腺坏死",
        "Pancreatic or peripancreatic fluid collection or peripancreatic fat necrosis": "胰腺或胰周积液或胰周脂肪坏死",
        "extrapancreatic hint": "符合以下一项或多项：\n• 胸腔积液\n• 腹水\n• 循环并发症\n• 实质并发症\n• 胃肠道受累",
        "Abnormal": "异常",
        "Severe Pancreatitis": "重度胰腺炎",
        "Mild Pancreatitis": "轻度胰腺炎"
      },
      hasScore:false,
      disabled:false,
      dataList1:[
        {value:"0",name:'正常胰腺',shortName:'正常'},
        {value:"2",name:'胰腺内部异常改变伴或不伴胰周脂肪炎性改变',shortName:'异常'},
        {value:"4",name:'胰腺或胰周积液或胰周脂肪坏死',shortName:'积液'},
      ],
      dataList2:[
        {value:"0",name:'无'},
        {value:"2",name:'≤ 30%'},
        {value:"4",name:'> 30%'},
      ],
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else { 
            form[key] = Number(form[key])
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return ''
      } else {
        // edema + necro + (complic * 2)
        let result = form.edema + form.necro + (form.complic * 2)
        console.log(result,'result----------------');
        self.hasScore = true
        return String(result)
      }
    }
  },
  
}



// WEBPACK FOOTER //
// ./src/pages/formulas/GIT/BalthazarCTModified.vue